import React, { useState } from 'react';
import './PasswordGate.css';

const PasswordGate = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (password === 'babaganoush') {
      localStorage.setItem('nekuda_auth', 'true');
      onAuthenticated();
    } else {
      setError('WRONG PASSWORD');
      setPassword('');
    }
  };

  return (
    <div className="password-gate">
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="PASSWORD"
          className="password-input"
          autoFocus
        />
        <button 
          type="submit" 
          className={`enter-button ${password.length === 0 ? 'invisible' : ''}`}
        >
          ENTER
        </button>
        {error && <div className="error-text">{error}</div>}
      </form>
    </div>
  );
};

export default PasswordGate;